import {Box} from '@chakra-ui/react';
import {colors, useOrderContext} from 'components/providers';
import {BottomStatusBar, Footer, Header, TawkMessenger} from 'components/shared';
import dynamic from 'next/dynamic';
import React, {FC, PropsWithChildren, ReactElement} from 'react';
import {ICategoryByProviderResponse, IRestaurantResponse, ProviderTypeEnum} from 'types';

import {IMetroCategory} from '../../metro/types';
import {ScrollToTopButton} from '../../shared/ScrollToTopButton';

interface Props {
  subheader?: ReactElement;
  categories?: ICategoryByProviderResponse[];
  providerType?: ProviderTypeEnum;
  providerName?: string;
  isDesktop: boolean;
  isFromHomePage?: boolean;
  customHeaderPt?: number;
  isMetro?: boolean;
  provider?: IRestaurantResponse;
  metroCategories?: IMetroCategory[];
  showScrollToTopButton?: boolean;
}

export const DefaultLayout: FC<PropsWithChildren<Props>> = ({
  children,
  subheader,
  categories,
  providerType,
  providerName,
  isDesktop,
  isFromHomePage,
  customHeaderPt,
  isMetro,
  provider,
  metroCategories,
  showScrollToTopButton,
}) => {
  const {ordersActive, orders, onHandlerSetLimit, isLoadingOrders} = useOrderContext();
  const headerRef = React.useRef<any>(null);
  const headerPt = customHeaderPt ? customHeaderPt : isDesktop ? 70 : 120;
  const MobileBottomNav = dynamic(() => import('components/mobile/MobileBottomNav').then((mod) => mod.default));

  return (
    <Box height="full" pt={`${headerPt + (subheader ? (isDesktop ? 80 : 40) : 0)}px`}>
      <Header
        providerType={providerType}
        providerName={providerName}
        isDesktop={isDesktop}
        orders={orders}
        ordersActive={ordersActive}
        onHandlerSetLimit={onHandlerSetLimit}
        isLoadingOrders={isLoadingOrders}
        ref={headerRef}
        isMetro={isMetro}
        provider={provider}
        categories={metroCategories}
      >
        {subheader}
      </Header>
      {isMetro ? (
        <Box id="main" as="main" w="full" bg={colors.samokatGray}>
          <Box maxW={isMetro ? '1800px' : '1440px'} mx="auto">
            {children}
            {showScrollToTopButton && (
              <ScrollToTopButton isFromHomePage={isFromHomePage} isDesktop={isDesktop} isMetro={isMetro} />
            )}
          </Box>
        </Box>
      ) : (
        <Box id="main" as="main" maxW={isMetro ? '1800px' : '1440px'} mx="auto" w="full">
          {children}
          <ScrollToTopButton isFromHomePage={isFromHomePage} />
        </Box>
      )}

      <Footer isDesktop={isDesktop} categories={categories} providerType={providerType} />

      {!isDesktop && isFromHomePage ? (
        <MobileBottomNav
          statusBar={
            <BottomStatusBar
              isDesktop={isDesktop}
              orders={orders}
              onHandlerSetLimit={onHandlerSetLimit}
              ordersActive={ordersActive}
              isLoadingOrders={isLoadingOrders}
              isFromHomePage={isFromHomePage}
            />
          }
        />
      ) : isMetro && isDesktop ? null : (
        <BottomStatusBar
          isDesktop={isDesktop}
          orders={orders}
          onHandlerSetLimit={onHandlerSetLimit}
          ordersActive={ordersActive}
          isLoadingOrders={isLoadingOrders}
        />
      )}
      <TawkMessenger />
    </Box>
  );
};
